import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import PageTitle from '@/components/PageTitle'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'
import NewsCard from './NewsCard'
import useFetchNews from '../../hooks/useFetchNews'

function NewsIntro() {
  const [newsList] = useFetchNews()
  const { t } = useTranslation()

  return (
    <div className={styles.NewsContainer}>
      <div>
        <PageTitle title={t('huanle activities')} subTitle="News" />
        <div className={styles.CardWrap}>
          {!!newsList.length &&
            newsList.map((item) => <NewsCard {...item} key={item.id} />)}
          <Link to="/news" className={styles.SeeMore}>
            {t('view more')}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default memo(NewsIntro)
